<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = withDefaults(
  defineProps<{
    size?: 'xs' | 'sm' | 'md'
    inline?: boolean
    label?: string
  }>(),
  { size: 'md', inline: false, label: '' },
)

const { t } = useI18n()
const text = computed(() => props.label || t('ui.spinner.loading'))
</script>

<template>
  <span
    :class="['ui-spinner', `ui-spinner--${size}`, { 'ui-spinner--inline': inline }]"
    role="status"
    :aria-label="text"
  >
    <span class="ui-spinner__ring" aria-hidden="true" />
    <span v-if="!inline" class="sr-only">{{ text }}</span>
  </span>
</template>

<style scoped>
.ui-spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ui-spinner__ring {
  display: block;
  border-radius: 50%;
  border: 2px solid var(--border-strong);
  border-top-color: var(--accent);
  animation: ui-spin 720ms linear infinite;
}

.ui-spinner--xs .ui-spinner__ring {
  width: 12px;
  height: 12px;
  border-width: 2px;
}

.ui-spinner--sm .ui-spinner__ring {
  width: 16px;
  height: 16px;
}

.ui-spinner--md .ui-spinner__ring {
  width: 26px;
  height: 26px;
  border-width: 3px;
}

@keyframes ui-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
